import React from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BlinkitOnboardingActions from "../../../store/actions/BlinkitOnboarding";
import BulkUploadFile from "../../BulkUploadFile";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Max upload limit is 1000.",
  "Date format should be DD-MM-YYYY.",
  "License's expiry-date should be atleast 2 months in future.",
  "Rider's age must be atleast 18.",
  "State/City names should be correctly spelt.",
  "Entries with duplicate `phone no`, `license no`, `pan no`, `account no` cannot exist in the CSV or already in the System",
];

const FileUploadModal = ({ getUploadUrl }) => {
  return (
    <BlinkitOnboardingUpload>
      <BulkUploadFile
        instructions={instructions}
        btnDataTestID="BlinkitOnboardingActionsUpload"
        uploadUrl="/blinkit-onboarding/bulk-upload/ack"
        sampleURL="/sample/bulk_upload_blinkit_onboarding.csv"
        id="bulkUploadBlinkitOnboardingModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Blinkit Onboarding upload"
        getUploadUrl={getUploadUrl}
      />
    </BlinkitOnboardingUpload>
  );
};

const BlinkitOnboardingUpload = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BlinkitOnboardingActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
